interface StatusBadgeProps {
  status: string;
  className?: string;
}

const statusStyles: Record<string, string> = {
  跟进中: 'bg-secondary-100 text-secondary-900 dark:bg-secondary-900 dark:text-secondary-100',
  反转更新: 'bg-primary-500 text-background-50 dark:text-foreground-950',
  最新回应: 'bg-accent-500 text-foreground-950',
  已完结: 'bg-background-200 text-foreground-700 dark:bg-background-800 dark:text-foreground-300',
};

export default function StatusBadge({ status, className = '' }: StatusBadgeProps) {
  const style = statusStyles[status] || 'bg-background-200 text-foreground-700';
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-xs font-medium font-label whitespace-nowrap ${style} ${className}`}
    >
      {(status === '跟进中' || status === '反转更新') && (
        <span className="w-1.5 h-1.5 rounded-full bg-current animate-pulse-soft"></span>
      )}
      {status}
    </span>
  );
}